import React from 'react';
import styled from 'styled-components';

interface Props {
  x?: number;
  y?: number;
  inline?: boolean;
  className?: string;
}

type NativeAttrs = Omit<React.HTMLAttributes<any>, keyof Props>;
export type SpacerProps = Props & NativeAttrs;

export const getMargin = (num: number): string => {
  return `calc(${num * 15.25}pt + 1px * ${num - 1})`;
};

const Spacer = React.memo(
  ({ x = 1, y = 1, inline = false, className = '', ...props }: SpacerProps) => {
    const left = getMargin(x);
    const top = getMargin(y);

    return (
      <StyledSpacer
        id="spacer"
        className={className}
        {...props}
        style={{
          display: inline ? 'inline-block' : 'block',
          marginLeft: left,
          marginTop: top,
        }}
      ></StyledSpacer>
    );
  },
);

Spacer.displayName = 'Spacer';

const StyledSpacer = styled.span`
  height: 1px;
  width: 1px;
`;

export default Spacer;
